//IMPORTAÇÕES
import React, { useEffect, useRef, useState } from 'react';
import { Button, Form } from 'react-bootstrap';

import SpinerVeye from '../../../components/spinnerVeye/spinnerVeye.js';
import { api_gateway } from '../../../conexoes/api'; 
// ICONES
import { setaDropdown } from '../../../utils/alternanciaIcones';
// SPINNER

/*  COMO USAR
    Importe a modal para dentro do componente que irá fazer uso dela.
    ex: import SelectSistema from '../../componentesModais/selects/selectSistema'

    Crie um hook apropriado para esconder e exibir a mensagem quando necessário.
    ex: const [revelarSelectSistema, setRevelarSelectSistema] = useState(false)

    Após isso, posicione-a dentro do return do seu componente e passe os props para
    customizar o conteúdo da mensagem da seguinte forma. É interessante utilizar um
    <Button/> com uma função onClick, dentro de um >Form.Group/> para que o campo
    se mantenha similar aos campos de texto normais.
    ex: <Form.Group>
            <Form.Label>
                <div className="fonte-cor-1 label-campo">Sistema {iconeAsterisco}</div>
            </Form.Label>
            { revelarSelectSistema === false &&
                <Button name="cdSistema" className="campo-texto-cor-3 campo-select" onClick={() => setRevelarSelectSistema(!revelarSelectSistema)}>
                    <div className="fonte-cor-1 label-campo">{dsSistema}</div>
                    <img className="campo-select-icone-desativado" src={setaDropdown()} alt="drop" />
                </Button>
            }
            { revelarSelectSistema === true &&
                <SelectSistema
                    setRevelarSelectSistema={setRevelarSelectSistema} //Hook para fechar a modal
                    setCdSistema={setCdSistema} //Código do Sistema
                    setDsSistema={setDsSistema} //Nome do Sistema
                    dsSistema={dsSistema} 
                    phSistema={phSistema} //Placeholder para mostrar o valor original em caso de edição
                >
                </SelectSistema>
            }
        </Form.Group>*/

export default function SelectSistema(props) {
    const [spinAtivo, setSpinAtivo] = useState(true);
    const [lsSistemas, setLsSistemas] = useState([])
    const modal = useRef();

    const handleClickFora = e => {
        if (!modal.current.contains(e.target)) {
            handleCancelar()
        }
    };

    function handleSistema(codigo, sistema){
        props.setCdSistema(codigo)
        props.setDsSistema(sistema)
        handleCancelar()
    }

    function handleCancelar(){
        props.setRevelarSelectSistema(false)
    }

    useEffect(() => {
        setSpinAtivo(true)
        async function renderSistemas(){
            const {data} = await api_gateway.get('/m1/consultar/sistema');
            
            if(data.dados.length > 0){
                let objetoSistemas = data.dados.map((item,i) => {
                    return (
                        <li key={"menu-"+item.ds_pav_sistema}>
                            <div className="campo-select-opcao campo-select-opcao-1" onClick={() => handleSistema(item.cd_pav_sistema, item.ds_pav_sistema) }>
                                <span className="fonte-cor-1 fonte-campo campo-select-opcao-label nao-selecionavel">{item.ds_pav_sistema}</span>
                            </div>
                            {data.dados[i+1]!=undefined&&<div className="campo-select-divisor-cor-1 campo-select-divisor" />}
                        </li>
                    );
                })
                setLsSistemas(objetoSistemas)
            }else{
                let objetoSistemas = () => {
                    return (
                        <li>
                            <div disabled className="campo-select-opcao campo-select-opcao-1">
                                <span className="fonte-cor-1 fonte-campo campo-select-opcao-label nao-selecionavel">Nenhuma informação encontrada</span>
                            </div>
                        </li>
                    );
                }
                setLsSistemas(objetoSistemas)
            }
            setSpinAtivo(false)
        }
        renderSistemas()
        document.addEventListener('mousedown', handleClickFora);
        return () => document.removeEventListener('mousedown', handleClickFora);
    }, [])


    return(
        <Form ref={modal}>
            { spinAtivo && <div className="componente-spinner-overlay"><div className="componente-spinner-container"><SpinerVeye/></div></div> }  
            <Button name="cdTipoPessoa" className="campo-texto-cor-3 campo-select" onClick={() => props.setRevelarSelectSistema(false)}>
                <div className="fonte-cor-1 label-campo">{props.dsSistema}</div>
                <img className="campo-select-icone-ativado" src={setaDropdown()} alt="drop" />
            </Button>
            <div className="campo-select-triangulo-cor-1 campo-select-triangulo" />
            <div className="campo-texto-cor-3 campo-select-corpo">
                <ul className="campo-select-lista">
                    {lsSistemas}
                </ul>
            </div>
        </Form>
    )
}